export default __webpack_public_path__ + "static/media/advantages_2.8a85bd3b.svg";